import apiClient from 'api/config/apiClient'

export default {
  async getAtosLoginData(payload) {
    return apiClient.request('atos', payload)
  },
}
